import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadResult, clearResult, deleteResult } from '../../common/results/actions'
import { Title } from '../components'
import { ResultForm } from '../forms'
import { roles } from '../../common/config'

class ResultPage extends React.Component {
  componentDidMount() {
    const { match, loadResult, result } = this.props
    const { params } = match
    if (params.result && (!result._id || params.result !== result._id)) loadResult(params.result)
  }
  componentWillUnmount() {
    this.props.clearResult()
  }
  onDelete() {
    var msg = this.result.archived ? 'Opravdu chcete obnovit toto hodnocení ?' : 'Opravdu chcete blokovat toto hodnocení ?'
    if (window.confirm(msg)) {
      this.deleteResult(this.result._id)
      window.location = '/results'
    }
  }
  render() {
    const { result, viewer } = this.props
    const title = `${result.driverFirstName} ${result.driverLastName}`
    return (
      <div>
        <Title message={title} />
        <aside className="breadcrumbs">
          <Link to="/results">Hodnocení</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <span>{title}</span>
          <div className="options">
            {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(viewer.role) !== -1 &&
              <button onClick={this.onDelete.bind(this.props)}>{this.props.result.archived ? 'Obnovit' : 'Blokovat'}</button>
            }
            {[roles.FLEET_MANAGER, roles.ADMIN].indexOf(viewer.role) !== -1 &&
              !!result.protocol &&
              <button onClick={() => window.open(`/${result.protocol}`)}>Export do PDF</button>
            }
            {[roles.FLEET_MANAGER, roles.ADMIN].indexOf(viewer.role) !== -1 &&
              !!result.certificate &&
              <button onClick={() => window.open(`/${result.certificate}`)}>Certifikát</button>
            }
          </div>
        </aside>
        <main className="form-page content">
          {!!result._id && <ResultForm result={result} viewer={viewer} /> }
        </main>
      </div>
    )
  }
}

ResultPage.propTypes = {
  viewer: React.PropTypes.object.isRequired,
  match: React.PropTypes.object.isRequired,
  result: React.PropTypes.object.isRequired,
  loadResult: React.PropTypes.func.isRequired,
  clearResult: React.PropTypes.func.isRequired,
  deleteResult: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  result: state.results.current,
  viewer: state.users.viewer,
}), { loadResult, clearResult, deleteResult })(ResultPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Result.js